import { deleteTitle, type ConfirmOptions, type ScreenHost } from "./ui.js";

export function deleteListMessage(total: number, done: number, dirty: boolean): string {
  const what = total === 0 ? "This empty list will be removed."
    : `This list and its ${total} ${total === 1 ? "item" : "items"}${done ? ` (${done} done)` : ""} will be removed.`;
  return `${what} You can't undo this in Trayflux.${dirty ? " Unsaved edits to an item will be discarded too." : ""}`;
}

/** Both entry points name the same loss; each screen owns its draft and navigation. */
export function confirmDeleteList(shell: ScreenHost, id: string, options: {
  dirty: boolean;
  cancel(): void;
  remove(): void;
  returnFocusTo: ConfirmOptions["returnFocusTo"];
}) {
  const list = shell.store.list(id);
  if (!list) return undefined;
  const all = shell.store.items(id);
  return shell.confirm({
    title: deleteTitle(list.name),
    message: deleteListMessage(all.length, all.filter(row => row.done).length, options.dirty),
    keep: { label: "Cancel", onChoose: options.cancel },
    act: { label: "Delete list", danger: true, onChoose: options.remove },
  }, { returnFocusTo: options.returnFocusTo });
}
